import { Entity } from '@/store/entity'

export class Survey extends Entity {
  get excerpt() {
    if (this.testimonial && this.testimonial.length > 100) {
      return this.testimonial.substr(0, 97) + '...';
    }

    return this.testimonial;
  }

  get answeredAtFormatted() {
    if (!this.answered_at) {
      return null;
    }

    return this.formatDate(this.answered_at, 'DD/MM/YYYY');
  }
}
